import { render, staticRenderFns } from "./CandidateCardComponent.vue?vue&type=template&id=043d5b8c&"
import script from "./CandidateCardComponent.vue?vue&type=script&lang=js&"
export * from "./CandidateCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCardComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VCard,VListItem,VListItemContent,VListItemSubtitle})
